import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/icons/basket_icon.svg'
import _imports_1 from '@/assets/icons/credit_card_plan.svg'


const _hoisted_1 = { class: "minimized-modal-card" }
const _hoisted_2 = {
  key: 0,
  width: "18",
  src: _imports_0,
  alt: "Basket Icon"
}
const _hoisted_3 = {
  key: 1,
  width: "18",
  src: _imports_1,
  alt: "Basket Icon"
}
const _hoisted_4 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["BeanPattern"], {
      color: $setup.MinimizedTypeUtils.getColor($props.minimized.type),
      class: "blob"
    }, null, 8 /* PROPS */, ["color"]),
    ($props.minimized.type == $setup.MinimizedType.BASKET)
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : _createCommentVNode("v-if", true),
    ($props.minimized.type == $setup.MinimizedType.BENEFITS_CARD)
      ? (_openBlock(), _createElementBlock("img", _hoisted_3))
      : _createCommentVNode("v-if", true),
    _cache[1] || (_cache[1] = _createElementVNode("div", { style: {"width":"var(--semantic-size-semantic-spacing-inline-150, 12px)"} }, null, -1 /* HOISTED */)),
    _createElementVNode("p", _hoisted_4, _toDisplayString($props.minimized.name), 1 /* TEXT */),
    _cache[2] || (_cache[2] = _createElementVNode("div", { style: {"width":"var(--semantic-size-semantic-spacing-inline-300, 24px)"} }, null, -1 /* HOISTED */)),
    _createVNode($setup["FontAwesomeIcon"], {
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($props.minimized.onMaximize?.call(null))),
      class: "maximize-icon",
      icon: $setup.Icons.imported.faUpRightAndDownLeftFromCenter
    }, null, 8 /* PROPS */, ["icon"])
  ]))
}